import { render, staticRenderFns } from "./TemplatesSelect.vue?vue&type=template&id=016d8078&"
import script from "./TemplatesSelect.vue?vue&type=script&lang=js&"
export * from "./TemplatesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports